<template>
    <div class="order-list record-detail">
        <div class="topNav">
            <navigation-bar Back/>
            <div class="help-info" @click="$router.push({name: 'OrderHelp',query:{i:recordList.takeoutId}})">幫助</div>
        </div>
        <div class="top-banner" id="top-banner">
            <el-image :src="banner" fit="cover" v-if="banner!==''"/>
            <el-image :src="require('@/assets/images/default_banner.svg')" fit="cover" v-else/>
        </div>

        <delivery-info v-if="deliveryInfoRefresh" :orderId="recordList.orderId" @deliveryInfoResult="deliveryInfoResult"></delivery-info>

        <div class="shadow-line mt-3 m-0"/>

        <!--todo 只有現金付款才出現此區塊，結帳成功和訂單取消此區塊也消失-->
        <div class="by-cash-reminder" v-show="isShowPaymentQRCodeBtn()" :key="qrcodeBtnKey + 'qrcodeBtnKey'">
            <div class="mt-4 mb-2 title">請於{{getPaymentDeadline()}}前至店內結帳完成</div>
            <p class="red">
                需至櫃檯或自助點餐機付款完成後<br>
                店家才會開始製作餐點</p>
            <el-button type="warning" round @click="clickShowQRCode()">
                <img src="../../assets/images/qrcode2.svg" class="mr-2"/>顯示結帳QR CODE
            </el-button>
            <div class="shadow-line mt-4 m-0"/>
        </div>

        <div v-if="false" class="d-flex m-3">
            <h4 class="mt-2 flex-grow-1"><img src="../../assets/images/delivery.svg" class="fixed-w-30 mr-2">由小短腿外送</h4>
            <div>
                <el-button round class="line-btn"><a href="http://line.me/ti/p/@pkf7762b" target="_blank">
                    <img src="../../assets/images/share-line.svg">聯繫小短腿</a>
                </el-button>
            </div>
        </div>

        <!--TODO 線上點餐＋候位預約點餐 才有以下區塊-->
        <template>
            <div class="top-cart-list">
                <h4>
                    我的訂單
                </h4>
                <meal v-for="(recordItem,index) in recordList.orderList" :recordItem="recordItem" :key="index" :index="index"></meal>
            </div>
        </template>

        <!--TODO 揪團點餐 才有以下區塊-->
        <template v-if="false">
            <div class="top-cart-list">
                <h4>
                    我的訂單
                </h4>
                <user style="margin: 10px 20px 0;"></user>
                <meal></meal>
                <meal></meal>
            </div>
            <div class="shadow-line m-0"></div>
            <div class="top-cart-list">
                <h4>
                    看看其他人都點甚麼
                </h4>
                <div class="cart-list team-buying">
                    <user></user>
                    <meal></meal>
                    <meal></meal>
                </div>
                <div class="cart-list team-buying">
                    <user></user>
                    <meal></meal>
                </div>
            </div>
        </template>

        <div class="shadow-line m-0 mb-3"></div>
        <div class="cart-list">
            <div class="li">
                小計
                <span class="float-right">$ {{recordList.totalPrice}}</span>
            </div>
            <div v-for="(couponItem,couponIndex) in recordList.discount" :key="couponIndex" class="li">
                {{couponItem.name}} {{'(X' + couponItem.amount + ')'}}
                <span class="float-right red">- $ {{couponItem.totalPrice}}</span>
            </div>
            <div v-for="(item,index) in recordList.otherDiscount" :key="index+'other'" class="li">
              <span>{{ item.name || "手動折價" }}
                <span class="float-right red">- $ {{ item.price }}</span>
              </span>
            </div>
            <div v-for="(item,index) in recordList.useRewardPointList" :key="index+'useRewardPoint'" class="li">
                {{ item.name }} <span class="small" >(X{{item.usePoint}}點)</span>
                <span class="float-right red">- $ {{ item.amount }}</span>
            </div>
            <div v-if="recordList.deliveryFee" class="li">
                外送費
                <span class="float-right red">$ {{recordList.deliveryFee}}</span>
            </div>
            <div v-if="recordList.buyerBan" class="li">
                統一編號
                <span class="float-right">{{recordList.buyerBan}}</span>
            </div>

            <el-divider class="mt-0 mb-2"></el-divider>
            <div class="li">
                總計(含稅)
                <span class="float-right red">$ {{recordList.invoicePrice}}</span>
            </div>
            <template v-if="recordList.customerNote">
                <el-divider class="mt-2 mb-3"></el-divider>
                <h4>備註</h4>
                <div>
                    {{recordList.customerNote}}
                </div>
            </template>
        </div>


        <div class="cart-list no-after" :key="isPayIndex + 'isPayIndex'">
            <h4>支付金額
                <!--todo 使用店內付款增加下面項目-->
                <span class="type red" v-if="!isPay() && recordList.orderStatus === 1">待付款</span>
                <span class="type green" v-else-if="isPay() && recordList.orderStatus === 1">已結帳</span>
                <span class="type" v-else-if="recordList.orderStatus === 2 || recordList.orderStatus === 3">{{ !isPay() ? "已取消" : "已退款" }}</span>
            </h4>
            <div class="li">
                {{this.recordList.payment.length > 0 ? `${this.recordList.payment[0].name}${ $public.notNull(this.recordList.payment[0].cardNumber) && this.recordList.payment[0].cardNumber !== "" ? ` (${this.recordList.payment[0].cardNumber})` : ""}` : "現金"}}
                <span class="float-right red">$ {{recordList.invoicePrice}}</span>
            </div>
        </div>
        <!--todo 重新下訂把資料倒到購物車-->
         <div class="CartButton" v-if="recordList.status === 4 || recordList.status === 5">
            <div class="button" @click="againOrder(recordList.onlineOrderStatus)" :disabled="!recordList.onlineOrderStatus">
                <div class="text">
                    <span v-if="recordList.onlineOrderStatus">再次下訂</span>
                    <span v-else>此店家目前無法接受訂單</span>
                </div>
            </div>
        </div>
        <comm-dialog :value="isShowQrcodeDialog" :outerContent="qrcodeDialogOuterContent" :isCancel="false"  positiveLabel="關閉"
                     :isIcon="isIcon" :isQrcode="isQrcode" :qrcodeSrc="qrcodeSrc"
                     @result="onCommDialogClose"
        />
        <el-dialog
              :visible.sync="isShowDialog"
              class="md"
              center>
            <div v-if="openDialogType === 'RejectOrder'" class="text-center">店家目前無法接受您的訂單，因為{{recordList.cancelReason}}，請您見諒。</div>
            <div v-else-if="openDialogType === 'CancelOrder'" class="text-center">您的訂單已取消，因為{{recordList.cancelReason}}。</div>
            <div v-else-if="openDialogType === 'CompleteOrder'" class="text-center">本次消費獲得優惠票券，已發送至您的禮物盒。
              <p v-for="(item, index) in  recordList.gift" :key="index">{{item.name}} X{{item.amount}}張</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="isShowDialog = false" round>確 定</el-button>
              </span>
        </el-dialog>
        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>
    </div>
</template>

<script>
    //import NavigationBar from '@/components/NavigationBar';
    import Meal from '@/views/order/components/Meal'
    import User from '@/views/order/components/User'
    import DeliveryInfo from '@/views/order/components/DeliveryInfo'
    import CommDialog from '@/components/CommDialog.vue';
    import {notNull} from '@/util/common';
    import * as mutationTypes from "@/store/mutationTypes";
    export default {
        name: "OrderRecordDetail",
        components: {
            //NavigationBar,
            Meal,//餐點
            User,//揪團大頭貼
            DeliveryInfo,//餐點進度資訊
            CommDialog,
        },
        data() {
            return {
                isLoading:false,
                isShowDialog:false,
                isShowQrcodeDialog: false,          //是否顯示QRCode dialog
                qrcodeDialogOuterContent: "",       //QRCode dialog 相關參數
                isIcon: false,                      //QRCode dialog 相關參數
                isQrcode: true,                     //QRCode dialog 相關參數
                qrcodeSrc: "",                      //QRCode dialog 相關參數，qr code 內容
                qrcodeBtnKey: 0,                    //是否顯示結帳按鈕
                orderSn: this.$route.query.orderSn!==undefined? this.$route.query.orderSn:0,
                recordList: {
                  payment:[],
                },
                isPayIndex: 0,                      //畫面更新用
                deliveryInfoRefresh:false,
                openDialogType: typeof this.$store.state.changePageData.type === 'undefined' ? '' : this.$store.state.changePageData.type,
                goToOrderCart: false,
                addCount: 0,
                addSqliteCount: 0,
                posMenuId: 0,
                banner:'',
            }
        },
        created() {
            this.setupData();
        },
        mounted() {

        },
        methods: {

            setupData(){
                this.$http.fetchWithAuth`GetOnlineOrderDetail${{
                    // orderId:this.$route.query.orderId!==undefined? Number(this.$route.query.orderId):0,
                    orderSn:this.orderSn,
                }}
                ${json => {
                    if (json.status) {
                        if (notNull(json.data)) {
                            this.recordList = json.data;
                            this.recordList.deliveryFee = Math.abs(this.recordList.deliveryFee);
                            this.isPayIndex++;      //更新畫面

                            // 刷新component
                            this.deliveryInfoRefresh = true;

                            if(this.openDialogType === 'RejectOrder' || this.openDialogType === 'CancelOrder' || (this.openDialogType === 'CompleteOrder' && this.recordList.gift != null && this.recordList.gift.length > 0)) {
                              this.isShowDialog = true

                              this.$store.commit('setChangePageData',{
                                isChangePage: false,
                                type:         "",
                              });

                            }

                            this.qrcodeBtnKey++;
                        }
                    }
                }}`;
            },

            againOrder(onlineOrderStatus) {
              if(!onlineOrderStatus) {
                  return false
              }

              let self = this
              self.isLoading = true
              self.$sqlite.query('select * from shopping_cart_meal_choiceList',[],(resultSet) => {
                let mealCount = resultSet.rows.length

                if(self.$store.state.cartStoreId === self.recordList.storeId || mealCount === 0) {
                  self.$store.commit("clearCartPageSnapshot");
                  self.$http.fetchWithAuth`AgainOrder${{
                    storeId:        self.recordList.storeId,
                    orderFoodList:  self.recordList.orderList,
                  }}
                  ${json => {
                      if (json.status) {
                        this.posMenuId = json.data.posMenuId
                        let whereString = json.data.orderFoodIdWhereList.join(",")
                        let orderFoodIdList = json.data.orderFoodIdList

                        self.$sqlite.query("select * from shopping_cart_meal_data where meal_id IN ("+whereString+")", orderFoodIdList, function(resultSet){

                          let addData = function() {
                            return new Promise(function (resolve, reject) {
                              for(let item of json.data.orderFoodDetailList) {
                                let hasData = false
                                for (let index = 0; index < resultSet.rows.length; index++) {
                                  const element = resultSet.rows.item(index);
                                  if(element.meal_id === item.posFoodInfo.id){
                                    hasData = true
                                    break
                                  }
                                }
                                if(!hasData) {
                                  self.addCount = self.addCount + 1
                                  setData(item)
                                }
                              }

                              resolve()
                            })
                          }

                          let addChoice = function() {
                            return new Promise(function (resolve, reject) {
                              for (let orderFoodData of self.recordList.orderList) {
                                for (let mealData of json.data.orderFoodDetailList) {
                                  if (orderFoodData.foodId === mealData.posFoodInfo.id) {
                                    self.addCount = self.addCount + 1
                                    setChoice(orderFoodData, mealData)
                                    break
                                  }
                                }
                              }

                              resolve()
                            })
                          }

                          let asyncRun = async () => {
                            await Promise.all([addData(), addChoice()])
                          };

                          asyncRun().then(function () {
                            if(json.message !== "") {
                              self.$public.showNotify(json.message, json.status);
                            }
                            self.goToOrderCart = true
                          })
                        });

                      } else {
                        self.$public.showNotify(json.message, json.status);
                        self.isLoading = false
                      }
                    }}`;
                } else {
                  self.$public.showNotify("購物車有其他店家資料", false);
                  self.isLoading = false
                }

                let setData = function(data){

                  let posFood = data;
                  let orderType = data.posFoodInfo.orderType;
                  let mealCombination = data.dataList;
                  // 單點帶入選項組合
                  if (orderType === 1) {
                    // 移除餐點註記
                    mealCombination = mealCombination.filter(function(item){
                      return item.noteType!==1 && item.posGoodsNoteDetailList.length > 0;
                    });
                  } else if (orderType === 2) {
                    // 移除餐點註記
                    mealCombination = mealCombination.map(function(item){
                      item.posFoodSubmealList.map(function (posFoodSubmeal) {
                        posFoodSubmeal.posFoodGoodsNoteList = posFoodSubmeal.posFoodGoodsNoteList.filter(function(posFoodGoodsNote){
                          return posFoodGoodsNote.noteType !== 1 && posFoodGoodsNote.posGoodsNoteDetailList.length > 0;
                        });
                        return posFoodSubmeal;
                      });
                      return item;
                    });
                  }

                  // 把要存進去的資料也濾掉註記跟沒有選項的
                  posFood.dataList = mealCombination;
                  self.$sqlite.insert('insert into shopping_cart_meal_data (meal_id, data_json) values (?, ?);', [posFood.posFoodInfo.id, JSON.stringify(posFood)],function(resultSet){
                    self.addSqliteCount = self.addSqliteCount + 1
                  });
                }

                let setChoice = function(orderFoodData, mealData){
                  let price = mealData.posFoodInfo.onlineOrderPrice
                  let posFood = mealData;
                  let orderType = mealData.posFoodInfo.orderType;
                  let mealCombination = mealData.dataList;
                  let tempChoiceList = []
                  if (orderType === 1) {
                    // 移除餐點註記
                    mealCombination = mealCombination.filter(function(item){
                      return item.noteType!==1 && item.posGoodsNoteDetailList.length > 0;
                    });
                    tempChoiceList = mealCombination.map((item)=>{
                      let preOption = [];
                      item.posGoodsNoteDetailList.forEach((posGoodsNoteDetail,posGoodsNoteDetailIndex) => {
                        // 預設選項
                        orderFoodData.noteList.forEach((noteItem) => {
                          if(noteItem.id === posGoodsNoteDetail.id){
                            price += posGoodsNoteDetail.increasePrice
                            preOption.push(posGoodsNoteDetailIndex);
                          }
                        })
                      });
                      return preOption;
                    });
                  } else if (orderType === 2) {
                    // 移除餐點註記
                    mealCombination = mealCombination.map(function(item){
                      item.posFoodSubmealList.map(function (posFoodSubmeal) {
                        posFoodSubmeal.posFoodGoodsNoteList = posFoodSubmeal.posFoodGoodsNoteList.filter(function(posFoodGoodsNote){
                          return posFoodGoodsNote.noteType !== 1 && posFoodGoodsNote.posGoodsNoteDetailList.length > 0;
                        });
                        return posFoodSubmeal;
                      });
                      return item;
                    });

                    tempChoiceList.push([])        //紀錄餐點
                    tempChoiceList.push([])        //紀錄選項
                    tempChoiceList[0] = mealCombination.map((item,index)=>{
                      let mainComboIndex = '';
                      let mainOption = '';
                      tempChoiceList[1][index] = []
                      item.posFoodSubmealList.forEach((posFoodSubmeal,posFoodSubmealIndex) => {
                        // 預設選項
                        if(orderFoodData.comboList[index].foodId === posFoodSubmeal.posFoodId) {
                          mainComboIndex = index
                          mainOption = posFoodSubmealIndex
                          price += posFoodSubmeal.increasePrice
                        }

                        tempChoiceList[1][index][posFoodSubmealIndex] = [];
                        posFoodSubmeal.posFoodGoodsNoteList.forEach((posFoodGoodsNote,posFoodGoodsNoteIndex)=>{
                          tempChoiceList[1][index][posFoodSubmealIndex][posFoodGoodsNoteIndex] = [];
                          if(mainComboIndex === index && mainOption === posFoodSubmealIndex) {
                            posFoodGoodsNote.posGoodsNoteDetailList.forEach((posGoodsNoteDetail, posGoodsNoteDetailIndex) => {
                              orderFoodData.comboList[index].noteList.forEach(noteItem => {
                                if (noteItem.id === posGoodsNoteDetail.id) {
                                  price += posGoodsNoteDetail.increasePrice
                                  tempChoiceList[1][index][posFoodSubmealIndex][posFoodGoodsNoteIndex].push(posGoodsNoteDetailIndex);
                                }
                              })
                            });
                          }
                        });
                      });
                      return mainOption;
                    });
                  }

                  price = price * orderFoodData.amount

                  self.$sqlite.query('select id,amount,choicePrice from shopping_cart_meal_choiceList where meal_id = ? and combination_json = ? and text_note = ?',[posFood.posFoodInfo.id, JSON.stringify(tempChoiceList), orderFoodData.noteText],function(resultSet){
                    // 如果有相同選項組合，就把數量合併
                    if (resultSet.rows.length>0) {
                      let id = resultSet.rows.item(0).id;
                      let amount = resultSet.rows.item(0).amount;
                      let choicePrice = resultSet.rows.item(0).choicePrice;
                      self.$sqlite.update('UPDATE shopping_cart_meal_choiceList SET amount=?, choicePrice=? WHERE id = ?',[amount+orderFoodData.amount, choicePrice+price, id],function(resultSet){
                        self.addSqliteCount = self.addSqliteCount + 1
                      });
                    }else{
                      // 沒有的話就新增
                      self.$sqlite.insert('insert into shopping_cart_meal_choiceList (meal_id,amount,combination_json,text_note,choicePrice) values(?,?,?,?,?)',[posFood.posFoodInfo.id, orderFoodData.amount, JSON.stringify(tempChoiceList), orderFoodData.noteText, price],function(resultSet){
                        self.addSqliteCount = self.addSqliteCount + 1
                      })
                    }
                  });
                }


              });
            },

            deliveryInfoResult(act,value){
              if (act==='renewBanner') {
                this.banner = value;
              }
            },

            /** 點擊顯示結帳QRCode按鈕 */
            clickShowQRCode() {
                //this.orderSn
                this.showQRCodeModal(this.recordList.orderId, 0, this.recordList.storeId);
            },

            /** 顯示結帳QRCode */
            isShowPaymentQRCodeBtn() {
                //這邊判斷的是 order 的 Status，訂單狀態(1:正常 2:取消 3:作廢)
                if (this.$public.notNull(this.recordList.orderStatus) &&
                    this.recordList.orderStatus === 1 ) {
                    if (this.$public.notNull(this.recordList.isPay)) {
                        return !this.recordList.isPay;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },

            /** 取得結帳期限 */
            getPaymentDeadline() {
                if (this.$public.notNull(this.recordList.workedAt)) {
                    //用date轉換 yyyy-mm-dd時間格式時，要把 '-' 轉換成 '/' ，不然在 ios會出現 NaN轉換錯誤
                    let workedAt = new Date(this.recordList.workedAt.replace(/-/g, '/'));
                    workedAt.setMinutes(workedAt.getMinutes()+30);
                    return this.$public.dateFormat("hh:mm", workedAt);
                } else {
                    return "";
                }
            },

            /** 顯示結帳QRCode */
            showQRCodeModal(orderId, tableId, storeId) {
                let self = this;
                //QRCode頁面資訊
                // self.tableQRCodeSetting.qrcodeText = tableNo;
                //要顯示的加密 QRCode 參數內容
                let dataToken = this.$crypto.objectToURIComponent({
                    "orderId": orderId,
                    "tableId": tableId,
                    "storeId": Number(storeId),
                    // "merchantType": constDefine.MerchantType.Store,
                    // "usedType": constDefine.QRCodeUsedType.TableOrderAddItem,
                    "tableOrderRoutePath": "/table-order/storeCode",
                })
                // self.$store.commit(mutationTypes.setQRCodeData, {
                //     "name": tableNo,
                //     "isShowBrandInfo":true,
                //     "brandInfo":this.brandName+" "+this.storeName,
                //     "params": process.env.VUE_APP_OINAPP_HOST + "order?dataToken=" + dataToken,
                // });

                self.qrcodeSrc = process.env.VUE_APP_OINAPP_HOST + "order?dataToken=" + dataToken ;
                self.qrcodeDialogOuterContent =  '付款 QRCode';
                self.isShowQrcodeDialog = true;
            },

            /** 取得是否結帳 */
            isPay() {
                if (this.$public.notNull(this.recordList.isPay)) {
                    return this.recordList.isPay;
                }
                return false;
            },

            /** CommDialog 關閉事件 */
            onCommDialogClose(result) {
                this.isShowQrcodeDialog = false;
                this.setupData();
            },
        },
        watch: {
          '$store.state.changePageData.isChangePage': function() {
            if(this.$store.state.changePageData.isChangePage) {
              if(this.$store.state.changePageData.isChangeOrderSn || this.$store.state.changePageData.orderSn === this.orderSn) {
                this.orderSn = this.$store.state.changePageData.orderSn
                this.deliveryInfoRefresh = false;
                this.openDialogType = this.$store.state.changePageData.type
                this.setupData()
              }

              this.$store.commit('setChangePageData',{
                isChangePage: false,
              });
            }
          },
          addSqliteCount: {
            handler:function () {
              let self = this
              if(self.goToOrderCart) {
                if(self.addCount === this.addSqliteCount) {
                  self.isLoading = false
                  let reservationData = {
                    reservationType: '1',
                    reservationDateIndex: 0,
                    reservationPeriodIndex: 0,
                    reservationTime: '',
                    posMenuId: this.posMenuId,
                  }
                  this.$store.commit(mutationTypes.setOrderStoreInfo, reservationData);
                  self.$store.commit('setCartStoreId',self.recordList.storeId)
                  self.$router.push({name: 'OrderCart'})
                }
              }
            },
            deep : true ,
            immediate : true,
          },
        }
    }
</script>
<style lang="less" scoped src="../../less/order.less"/>
